import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import capitalize from "capitalize";
import { formatPrice, lowercaseAndParseSpaces } from "../../utils";
import config from "../../config"; // Components

import { useEnquireForm } from "../EnquiryForm";
import SocialSharing from "../SocialSharing";
import Button from "../Button";
import CompareButton from "./components/CompareButton";
import Icon from "../Icon";
import EstateLabel from "./EstateLabel";
import "./OldPackage.scss";
var isUserMenuEnabled = config.userCustomisationMenu.get("enabled"),
    NB_SLUG = config.get("api.neighbourhood"),
    TYPES = config.get("propertyTypes"),
    STATUS = config.get("status"),
    ATTRIBUTES = config.get("attributes"),
    showPriceNextToLotOnly = config.otherOptions.get("masterplan.show_price_next_to_lot_only"),
    showPriceNextToLot = config.otherOptions.get("masterplan.show_price_next_to_lot"),
    showPrice = showPriceNextToLotOnly || showPriceNextToLot; // @TODO find a better name for the "view" props

export var Package = function Package(a) {
  var b,
      c = a.view,
      d = a.isDetail,
      e = a.isSlider,
      f = a.isLot,
      g = a.isSummary,
      h = a.releaseFlyer,
      i = a.showScrollToMap,
      j = a.className,
      k = a.onClick,
      l = a.disableClicks,
      m = a.showNameAsLotName,
      n = a.showShare,
      o = a.children,
      p = a.disableFlyerBtn,
      q = a.disableViewBtn,
      r = _objectWithoutProperties(a, ["view", "isDetail", "isSlider", "isLot", "isSummary", "releaseFlyer", "showScrollToMap", "className", "onClick", "disableClicks", "showNameAsLotName", "showShare", "children", "disableFlyerBtn", "disableViewBtn"]),
      s = useEnquireForm(),
      t = r.package || {},
      u = t.propertyType ? TYPES[t.propertyType] : null,
      v = "land" === t.propertyType,
      w = "apartment" === t.propertyType,
      x = v ? t.name : t.lot_name,
      y = v ? STATUS[t.status] : t.name,
      z = t.total_area || t.lot_area || t.area,
      A = t.lot_frontage || t.frontage,
      B = t.image && "object" == typeof t.image ? t.image.url : t.image,
      C = t.flyer,
      D = t.lot_flyer,
      E = t.attributes || [],
      F = formatPrice(t.price),
      G = config.flags(t.flags),
      H = d || f ? "div" : Link;

  t.slug = t.slug ? t.slug.toString() : "";
  var I = v ? config.routes.get("landforsale.masterplan", NB_SLUG ? t.release_slug : "".concat(t.neighbourhood_slug, "/").concat(t.release_slug), "lot", t.slug) : config.routes.get("houseandland", t.slug),
      J = i && document.getElementById("zoommap"),
      K = t.project_slug ? config.estates.get(t.project_slug) : {},
      L = t.neighbourhood_slug ? config.neighbourhoods.get(t.neighbourhood_slug) : {},
      M = {
    logo: t.builder_logo,
    name: t.builders_name,
    slug: t.builders_slug
  },
      N = !isUserMenuEnabled && (f || d);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !g && /*#__PURE__*/React.createElement("div", {
    className: classnames("package", j, {
      isDetail: d,
      isLot: f
    })
  }, d || f ? null : /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--image",
    onClick: k
  }, /*#__PURE__*/React.createElement("img", {
    src: B,
    alt: v ? x : y,
    width: "100%",
    className: "package--image__render"
  }), /*#__PURE__*/React.createElement(EstateLabel, {
    estate: K,
    neighbourhood: L,
    builder: M
  }), G ? /*#__PURE__*/React.createElement("span", {
    className: "package--image__flag"
  }, G) : null), /*#__PURE__*/React.createElement("div", {
    className: "package--content"
  }, /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--subtitle",
    onClick: k
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--subtitle__type"
  }, f ? t.release_name : u), /*#__PURE__*/React.createElement("span", {
    className: "package--subtitle__options"
  }, E.map(function (a) {
    if (!ATTRIBUTES[a]) return null;
    var b = lowercaseAndParseSpaces(ATTRIBUTES[a]);
    return /*#__PURE__*/React.createElement(Icon, {
      key: b,
      icon: b,
      title: capitalize.words(b)
    });
  }))), /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--title",
    onClick: k
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("span", null, x ? /*#__PURE__*/React.createElement(React.Fragment, null, "house" === t.propertyType ? "Lot " : "", x) : y), /*#__PURE__*/React.createElement("span", {
    className: classnames((b = {
      single: !x
    }, _defineProperty(b, y.toLowerCase(), v), _defineProperty(b, "hasAfter", showPrice && v), b))
  }, x ? y : t.release_name || ""), showPrice && v ? /*#__PURE__*/React.createElement("span", null, F) : null), J ? /*#__PURE__*/React.createElement(Icon, {
    icon: "marker_orange",
    onClick: function scrollToMap() {
      var a = document.getElementById("zoommap");
      return !!a && void window.scrollTo({
        top: a.offsetTop,
        left: 0,
        behavior: "smooth"
      });
    }
  }) : null), w ? /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--details",
    onClick: k
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__label"
  }, "Size"), " ", z, "m\xB2"), /*#__PURE__*/React.createElement("span", {
    className: "package--details__item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__label"
  }, "Level"), " ", t.level), /*#__PURE__*/React.createElement("span", {
    className: "package--details__item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__label"
  }, "Aspect"), " ", t.aspect)) : /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--details",
    onClick: k
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__label"
  }, "Land size"), " ", z, "m\xB2"), /*#__PURE__*/React.createElement("span", {
    className: "package--details__item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--details__label"
  }, "Frontage"), " ", A ? /*#__PURE__*/React.createElement(React.Fragment, null, A, "m") : "n/a")), !v && /*#__PURE__*/React.createElement(H, {
    to: I,
    className: "package--specs",
    onClick: k
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--price__from"
  }, "From"), /*#__PURE__*/React.createElement("span", {
    className: classnames("package--price__number", {
      "ta-no-price": "-" === F
    })
  }, F, d && t.promoted ? "*" : "")), /*#__PURE__*/React.createElement("span", {
    className: "package--amenities"
  }, t.bedrooms && /*#__PURE__*/React.createElement("span", null, t.bedrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bedroom"
  })), t.bathrooms && /*#__PURE__*/React.createElement("span", null, t.bathrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bathroom"
  })), t.living && /*#__PURE__*/React.createElement("span", null, t.living, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "living"
  })), t && 0 !== t.garage && /*#__PURE__*/React.createElement("span", null, t.garage, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "garage"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classnames("package--buttons", "package--buttons-enquire")
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    className: classnames({
      "ta-width-100": N
    }),
    onClick: l ? null : function (a) {
      "function" == typeof k && k(a), s(_objectSpread({}, t, {
        name: x ? "".concat(x, ", ").concat(y) : "".concat(u, " ").concat(y, ", ").concat(t.release_name),
        url: I
      }));
    }
  }, "Enquire"), p || d || f ? null : /*#__PURE__*/React.createElement(Button, {
    href: C,
    external: !0,
    color: "secondary",
    size: "small"
  }, "Flyer"), N ? null : /*#__PURE__*/React.createElement(CompareButton, {
    className: "ta-btn-compare",
    size: "small",
    pkg: t,
    packageLink: I,
    onViewClick: k,
    onlyCompare: f && !d || d,
    onlyView: q || !isUserMenuEnabled && !d && !f
  }), f && !d ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    href: h,
    color: "secondary",
    size: "small",
    className: "ta-btn-release-flyer",
    external: !0
  }, "Release Flyer"), /*#__PURE__*/React.createElement(Button, {
    href: C,
    color: "secondary",
    size: "small",
    className: "ta-btn-lot-flyer",
    external: !0
  }, "Lot Flyer")) : null), d && t.inclusions ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Inclusions"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t.inclusions
    }
  })) : null, d && t.building_amenities ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Building Amenities"), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t.building_amenities
    }
  })) : null, d && t.colour_scheme ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Color Scheme"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    dangerouslySetInnerHTML: {
      __html: t.colour_scheme
    }
  }))) : null, n ? /*#__PURE__*/React.createElement("div", {
    className: "package--inclusions"
  }, /*#__PURE__*/React.createElement("h5", null, "Share"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(SocialSharing, null))) : null, d && /*#__PURE__*/React.createElement("div", {
    className: "package--buttons package--buttons__downloads"
  }, C && /*#__PURE__*/React.createElement(Button, {
    href: C,
    external: !0,
    icon: "download",
    color: "secondary",
    size: "small"
  }, "Package"), D && /*#__PURE__*/React.createElement(Button, {
    href: D,
    external: !0,
    icon: "download",
    color: "secondary",
    size: "small"
  }, "Lot")), o)), g && /*#__PURE__*/React.createElement("div", {
    className: classnames("package--summary", {
      isSummary: g
    })
  }, /*#__PURE__*/React.createElement(Link, {
    to: I,
    className: "package--summary--link",
    onClick: k
  }, /*#__PURE__*/React.createElement("div", {
    className: "package--summary--image"
  }, /*#__PURE__*/React.createElement("img", {
    src: B,
    alt: v ? x : y,
    width: "100%",
    className: "package--summary--image__render"
  })), /*#__PURE__*/React.createElement("div", {
    className: "package--summary--content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "package--summary--title"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("span", null, m ? t.name : "Lot ".concat(x)), /*#__PURE__*/React.createElement("span", {
    className: "package--summary--price lot"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--summary--price__from"
  }, "From"), /*#__PURE__*/React.createElement("span", {
    className: "package--summary--price__number"
  }, F)))), /*#__PURE__*/React.createElement("div", {
    className: "package--summary--specs"
  }, /*#__PURE__*/React.createElement("span", {
    className: "package--summary--amenities"
  }, t.bedrooms && /*#__PURE__*/React.createElement("span", null, t.bedrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bedroom"
  })), t.bathrooms && /*#__PURE__*/React.createElement("span", null, t.bathrooms, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "bathroom"
  })), t.living && /*#__PURE__*/React.createElement("span", null, t.living, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "living"
  })), t && 0 !== t.garage ? /*#__PURE__*/React.createElement("span", null, t.garage, " ", /*#__PURE__*/React.createElement(Icon, {
    icon: "garage"
  })) : null))))));
};
export default Package; // <Package detailed/>
// <Package summary/>